// removed by extract-text-webpack-plugin
module.exports = {"radioLabel":"privacy_about-our-ads_radioLabel","button":"privacy_about-our-ads_button","saveSuccess":"privacy_about-our-ads_saveSuccess","saveError":"privacy_about-our-ads_saveError"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/privacy-widgets/src/components/about-our-ads/style.less
// module id = 589
// module chunks = 9 12